import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useAdminExportTransit = () => {
  return useMutation({
    mutationFn: async (transitId: string) => {
      const response = await request({
        path: `admin/export-transit/${transitId}`,
        method: 'GET',
        authenticate: true,
        responseType: 'blob',
      });

      return { data: response, transitId };
    },
    onSuccess: ({ data, transitId }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `transit-${transitId}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('Transit export downloaded successfully');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error exporting transit');
    },
  });
};
